import { FormControl, type IFormikFormControlProps } from './FormControl'
import { getFormControlProps } from './utils/getFormControlProps'
import {
  type IPhoneNumberFieldProps,
  PhoneNumberField,
} from '../../elements/PhoneNumberField'

export interface IFormPhoneNumberFieldProps
  extends Omit<IPhoneNumberFieldProps, 'name' | 'id' | 'helperText'>,
    IFormikFormControlProps {}

export const FormPhoneNumberField = (props: IFormPhoneNumberFieldProps) => {
  const { id, name, disabled, ...formControlProps } = getFormControlProps(props)

  return (
    <FormControl id={id} name={name} disabled={disabled} {...formControlProps}>
      {({ value, handleChange, handleBlur, error }) => (
        <PhoneNumberField
          id={name}
          name={name}
          disabled={disabled}
          {...props}
          variant='standard'
          onChange={(newValue) => handleChange(newValue ?? '')}
          onBlur={handleBlur}
          value={value}
          error={error}
          defaultCountry={props.defaultCountry}
        />
      )}
    </FormControl>
  )
}
